export { NarratorsController } from './NarratorsController';
export { HadithController } from './HadithController';
